<template>
  <naj-box
    :title="basicInfoLocal.requestOwner.title"
    no-gutters
  >
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <template v-else>
      <p class="px-5 section-header">
        {{ local.bankruptcy.debtorForm.title }}
      </p>
      <info-list
        :form-model="debtorsDetails"
        :headers="headersDebtors"
      ></info-list>
      <v-row v-if="requestOwnerTypeId == requestOwnerTypeEnum.creditor">
        <v-col cols="6">
          <p class="px-5 section-header">
            {{ local.bankruptcy.creditorForm.title }}
          </p>
          <info-list
            :form-model="creditorsDetails"
            :headers="headersCreditors"
          ></info-list>
        </v-col>
        <v-col cols="6">
          <p class="px-5 section-header">
            {{ local.bankruptcy.common.informationDebt }}
          </p>
          <info-list
            :form-model="creditorsDetails"
            :headers="headersDebt"
          ></info-list>
        </v-col>
      </v-row>
    </template>
  </naj-box>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import InfoList from '@/modules/bankruptcy/components/bankruptcy-file/info-list.vue';
import { toHijriDate } from '@/helpers/utils';
import { requestOwnerTypeEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  name: 'RequestOwner',
  components: { InfoList },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
    requestOwnerTypeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      requestOwnerTypeEnum,
      debtorsDetails: {},
      creditorsDetails: {},
      loading: false,
      toHijriDate,
      headersDebt: [
        {
          key: 'debtValue',
          text: this.local.bankruptcy.creditorForm.debtValue,
          size: 12,
        },
        {
          key: 'debtOrigin',
          text: this.local.bankruptcy.creditorForm.debtOrigin,
          size: 12,
        },
        {
          key: 'dueDate',
          text: this.local.bankruptcy.creditorForm.dueDate,
          formatter: toHijriDate,
          size: 12,
        },
        {
          key: 'paymentStatus',
          text: this.local.bankruptcy.creditorForm.paymentStatus,
          size: 12,
        },
        {
          key: 'receivedPayment',
          text: this.local.bankruptcy.creditorForm.receivedPayment,
          size: 12,
        },
        {
          key: 'remainingPayment',
          text: this.local.bankruptcy.creditorForm.remainingPayment,
          size: 12,
        },
      ],
      headersCreditors: [
        {
          key: 'fullName',
          text: this.local.bankruptcy.requestApplicant.fullName,
          size: 12,
        },
        {
          key: 'organizationName',
          text: this.local.bankruptcy.debtorForm.organizationName,
          size: 12,
        },
        {
          key: 'commercialRegistrationNumber',
          text: this.local.bankruptcy.identityVerificationForm.commercialRegistrationNumber,
          size: 12,
        },
        {
          key: 'managerFullName',
          text: this.local.bankruptcy.identityVerificationForm.managerFullName,
          size: 12,
        },
        {
          key: 'managerIdentityNumber',
          text: this.local.bankruptcy.identityVerificationForm.managerIdentityNumber,
          size: 12,
        },
        {
          key: 'unifiedNumber',
          text: this.local.bankruptcy.identityVerificationForm.unifiedNumber,
          size: 12,
        },
        {
          key: 'identityTypeName',
          text: this.local.bankruptcy.requestApplicant.socialIdType,
          size: 12,
        },
        {
          key: 'identityNumber',
          text: this.local.bankruptcy.requestApplicant.socialId,
          size: 12,
        },
        {
          key: 'dateOfBirth',
          text: this.local.bankruptcy.requestApplicant.birthDate,
          formatter: (val) => { return this.toHijriDate(val) || '---'; },
          size: 12,
        },
        {
          key: 'nationalityName',
          text: this.local.bankruptcy.requestApplicant.nationality,
          size: 12,
        },
        {
          key: 'mobile',
          text: this.local.bankruptcy.debtorForm.mobile,
          size: 12,
        },
        {

          key: 'email',
          text: this.local.bankruptcy.debtorForm.email,
          size: 12,
        },
      ],
      headersDebtors: [
        {
          key: 'fullName',
          text: this.local.bankruptcy.requestApplicant.fullName,
        },
        {
          key: 'organizationName',
          text: this.local.bankruptcy.debtorForm.organizationName,
        },
        {
          key: 'headquarter',
          text: this.local.bankruptcy.debtorForm.headquarter,
        },
        {
          key: 'commercialRegistrationNumber',
          text: this.local.bankruptcy.identityVerificationForm.commercialRegistrationNumber,
        },
        {
          key: 'identityTypeName',
          text: this.local.bankruptcy.requestApplicant.socialIdType,
        },
        {
          key: 'unifiedNumber',
          text: this.local.bankruptcy.identityVerificationForm.unifiedNumber,
        },
        {
          key: 'region',
          text: this.local.bankruptcy.debtorForm.region,
        },
        {
          key: 'identityNumber',
          text: this.local.bankruptcy.requestApplicant.socialId,
        },
        {
          key: 'city',
          text: this.local.bankruptcy.debtorForm.city,
        },
        {
          key: 'dateOfBirth',
          text: this.local.bankruptcy.requestApplicant.birthDate,
          formatter: (val) => { return this.toHijriDate(val) || '---'; },
        },
        {
          key: 'debtorClassificationName',
          text: this.local.bankruptcy.debtorForm.classification,
        },
        {
          key: 'nationalityName',
          text: this.local.bankruptcy.requestApplicant.nationality,
        },
        {
          key: 'isOrganizedEntity',
          text: this.local.bankruptcy.debtorForm.isOrganizedEntity,
          formatter: (val) => { return val ? this.local.common.yes : this.local.common.no; },
        },
        {
          key: 'gender',
          text: this.local.bankruptcy.requestApplicant.gender,
          formatter: (val) => { return val == 1 ? this.local.bankruptcy.genders.male : (val == 2 ? this.local.bankruptcy.genders.female : '---'); },
        },
        {
          key: 'organizedEntityTypeName',
          text: this.local.bankruptcy.debtorForm.organizedType,
        },
        {
          key: 'otherOrganizedEntityType',
          text: this.local.bankruptcy.debtorForm.otherOrganizedType,
        },
        {
          key: 'mobile',
          text: this.local.bankruptcy.debtorForm.mobile,
        },
        {
          key: 'isSpecifiedOrganization',
          text: this.local.bankruptcy.debtorForm.isSpecifiedOrganization,
          formatter: (val) => { return val ? this.local.common.yes : this.local.common.no; },
        },
        {

          key: 'email',
          text: this.local.bankruptcy.debtorForm.email,
        },
        {
          key: 'specifiedOrganizationName',
          text: this.local.bankruptcy.debtorForm.specifiedOrganizationName,
        },
        {
          key: 'phone',
          text: this.local.bankruptcy.debtorForm.phone,
        },
        {
          key: 'specifiedOrganizationUnifiedNumber',
          text: this.local.bankruptcy.debtorForm.specifiedOrganizationUnifiedNumber,
        },
        {
          key: 'bankruptcyProofs',
          text: this.local.bankruptcy.debtorForm.bankruptcyProofs,
          size: 12,
          disableSplit: true,
        },
      ],
      basicInfoLocal: this.local.bankruptcy.bankruptcyFile.basicInfo,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.loading = true;
    this.getDebtorsDetails(this.requestObjectKey)
      .then((res) => {
        this.debtorsDetails = res.data;
      })
      .finally(() => {
        this.loading = false;
      });

    if (this.requestOwnerTypeId == requestOwnerTypeEnum.creditor) {
      this.getCreditorDetails(this.requestObjectKey)
        .then((res) => {
          this.creditorsDetails = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: { ...mapActions(['getDebtorsDetails', 'getCreditorDetails']) },
};

</script>

<style lang="scss" scoped>
.section-header {
  color: var(--app-dark-primary-color);
  font: normal normal bold 20px/31px Almarai;
}
</style>
